export enum QueryKey {
  BackendVersions = "status",
  BeneinfoProviders = "beneinfo/providers",
  Counties = "geography/counties",
  CwPremiumRanges = "plans/premiumranges",
  DrugCosts = "drugs/cost",
  DrugsByLetter = "drugs/list",
  DrugsByLetterPap = "pap/drugs/list",
  Facilities = "/providers/facilities",
  FacilityNames = "/providers/facilities/autocomplete",
  FrontEndVersion = "version",
  InNetworkPharmacySearch = "geography/plan/pharmacies",
  MapboxForward = "mapbox/forward",
  MedigapCoverages = "other-insurance",
  MedigapPlanPremiumRanges = "medigap/plans",
  MedigapPolicies = "medigap/policies",
  PACEStates = "plans/pace/states",
  PAPPlans = "pap/drug-programs",
  PendingEnrollments = "oec-status",
  PharmacySearch = "geography/pharmacies",
  Plan = "plan",
  PlanCard = "plan/card",
  PlansSearch = "plans/search",
  PractitionersSearch = "providers/practitioners",
  PrescriptionDrugEvents = "beneinfo/prescription-drug-events",
  RolloverCoverage = "beneinfo/rollover-coverage",
  SPAPPlans = "pap/state-programs",
  SPAPStates = "pap/states",
  StatusSummary = "status-summary",
  ValidateMbi = "beneinfo/validate-mbi",
}

export enum StaleTime {
  /** default stale time */
  Zero = 0,
  /**
   * 5 second buffer to avoid duplicate calls if, for example,
   * two components render one after another, both of which need query data
   * TODO: Have discussion about this value with team. This is an initial stab.
   * */
  AvoidDuplicateQueries = 5 * 1000,
  /** one hour stale time for data that updates very infrequently */
  InfrequentUpdates = 60 * 60 * 1000,
  /** never stale, data that we expect to be unchanging */
  Infinite = Infinity,
}
